import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody, CardTitle, Badge, Button, Table, } from "reactstrap";
import { Trans, useTranslation } from "react-i18next";
import { useClient } from "hooks";

const Docs = ({ isAuthenticated }) => {

    const client = useClient();

    const { t } = useTranslation();
    const { i18n } = useTranslation();
    const dir = i18n.dir();



    useEffect(() => {

    }, [])



    return (
        <Container className="mt-5 container-fluid docs">
            <Row>
                <Col md={{ size: 12, }}>
                    <h1 className="text-left mb-4">Integrations Documentation V0.2.0</h1>
                    <h3 className="text-left my-4">I. Integration</h3>
                    <Card>
                        <CardBody className="bg-white">
                            <CardTitle tag="h5">1. Application Creation</CardTitle>
                            <p>
                                <Trans>In this phase, we create the application for our clients, Once we receive a request, we need the <strong>redirect_url</strong> and we will create an application and send you the <strong>client_id</strong>, <strong>client_secret</strong></Trans>
                            </p>
                            <p className="">
                                <Trans>These information (client_id, client_secret) will be provided with other urls separately to the client manually for now</Trans>
                            </p>

                        </CardBody>
                    </Card>
                    <Card>
                        <CardBody className="bg-white">
                            <CardTitle tag="h5">2. Authentication</CardTitle>
                            <p>
                                <Trans>2.1 Users will click on <span className="badge badge-primary p-2">LINK TO HESSAB</span> from the client application for authorization</Trans>
                            </p>
                            <p className="ml-3">
                                - Authorization URL: <a href="https://hesaabaccounting.com/auth">https://hesaabaccounting.com/auth</a>
                            </p>
                            <p>
                                In addition to the base URL mentioned above, OAuth 2.0 also uses query parameters to pass information during the authentication process.
                                <br />
                            </p>
                            On the Authentication request these parameters should be included:
                            <p><span className="badge badge-dark">client_id</span> : your_client_id,</p>
                            <p><span className="badge badge-dark">redirect_uri</span> : https://client-app.com/callback,</p>
                            <p><span className="badge badge-dark">response_type</span> : code,</p>
                            <p><span className="badge badge-dark">scope</span> : read write,</p>

                            <p>
                                Example: <code>https://hesaabaccounting.com/auth?client_id=your_client_id&response_type=code&redirect_uri=https://client-app.com/callback&scope=read</code>
                            </p>

                            <div className="border-top py-3">
                                2.2 User will be asked to enter its credentials then select an organisation to link with <span className="text-warning">(The organisation must be active in Hessab and linked to Xero)</span>
                                <p>If the access has been authorized, the user will be redirected to the Callback URL with the authorization code, code verifier and state in the code query parameter, which you can fetch and send to the token endpoint to continue the process of obtaining the access token:</p>
                                <p>
                                    Example: <code>https://yourapp.com/callback?code={"code_value"}&code_verifier={"code_verifier"}&state={"state_value"}</code>
                                </p>

                                <div className="alert alert-warning" role="alert">
                                A simple warning alert—check it out!
                                </div>
                            </div>

                            {/* <Table bordered style={{fontSize:"1rem"}}>
                                <thead>
                                    <tr>
                                        <td> QUERY PARAMETER </td>
                                        <td> DESCRIPTION  </td>
                                        <td> EXAMPLE </td>
                                        
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td scope="row"> <span className="badge badge-dark p-2">client_id</span> </td>
                                        <td> Identifies the client application making the request, which values can be fetched from your application on Hessab </td>
                                        <td> 1311508470xxx </td>
                                    </tr>
                                    
                                    <tr>
                                        <td scope="row"> <span className="badge badge-dark p-2">client_id</span> </td>
                                        <td> Identifies the client application making the request, which values can be fetched from your application on Hessab </td>
                                        <td> 1311508470xxx </td>
                                    </tr>
                               
                                    <tr>
                                        <td scope="row"> <span className="badge badge-dark p-2">client_id</span> </td>
                                        <td> Identifies the client application making the request, which values can be fetched from your application on Hessab </td>
                                        <td> 1311508470xxx </td>
                                    </tr>

                                    
                                    
                                </tbody>
                            </Table> */}

                        </CardBody>
                    </Card>


                    <Card>
                        <CardBody className="bg-white">
                            <CardTitle tag="h5">3. Access Token Generation</CardTitle>
                            <p className="">
                                <h6>3.1Access Token Request</h6>
                                <Trans> After authentication, on the Callback_URL a <strong>code</strong>, <strong>code_verifier</strong>, and <strong>state</strong> will be returned  Use them in your access token request, which is a POST request with the required parameters to the token endpoint.</Trans>
                            </p>
                            <p className="ml-3">
                                - Token Endpoint: <a href="https://hesaabaccounting.com/api/o/token/">https://hesaabaccounting.com/api/o/token/</a>
                            </p>

                            <h6>Body Definition</h6>
                            <p>
                                The following enlists the values that are sent to the User Authorization endpoint to generate an access token:
                            </p>
                            <div className="ml-4">
                                <code>&#123;
                                    <br />
                                    client_id:"FSTEWREyHcDT95R3EXXXX"
                                    <br />
                                    client_secret:"123456789"
                                    <br />
                                    code:"FZmZgk4EKtbUerXXXXX"
                                    <br />
                                    code_verifier:"PbhkANeHPbRXXX"
                                    <br />
                                    grant_type:"authorization_code"
                                    <br />
                                    redirect_uri:"https://your-client-app.com/callback"
                                    <br />
                                    state:"8961aeae-db3f-4203-90cf-8912b6e8f189"
                                    <br />
                                    &#125;
                                </code>
                            </div>
                            <div className="py-3 border-top">
                                <h6>3.2 Access Token Response</h6>
                                After a successful POST request, a token response will be received
                                <p className="">
                                    <code>
                                        &#123;
                                        <br />
                                        "access_token": "JhTWVtNHZ2zuVxY0MK6rX6opkRAsVS",
                                        <br />
                                        "expires_in": 36000,
                                        <br />
                                        "token_type": "Bearer",
                                        <br />
                                        "scope": "write",
                                        <br />
                                        "refresh_token": "PTxVpHqshxwqqR1G3u2hwjW5NTae86"
                                        <br />
                                        &#125;
                                    </code>
                                </p>
                            </div>
                            Now you may use the access token to make GET or POST requests to Hessab, Different Endpoints will be added later
                        </CardBody>
                    </Card>


                    <Card className="mt-4">
                        <CardBody className="bg-white">
                            <CardTitle tag="h5">4. Client Access Token (Optional)</CardTitle>
                            <p>
                                So far the client user received Hessab token, hence, Client Application can access Hessab protected resources,
                                <br />
                                But for a reverse access (Hessab accessing client resources) an <span className="text-warning">access token</span> token needs to be granted to hessab,
                            </p>
                            <p className="ml-3">
                                - Reverse Token Endpoint: <a href="https://hesaabaccounting.com/api/oauth2/reverse/token">https://hesaabaccounting.com/api/oauth2/reverse/token</a>
                            </p>
                            <p>
                                Use the above endpoint to send you client application access_token to Hessab to enable a two ways connection, a token needs to be sent to the above url,
                                <br />
                                <strong>Body Definition</strong>
                                <p>
                                    <code>
                                        &#123;
                                        <br />
                                        "reverse_token": "JhTWVtNHZ2xxxxxX6opkRAsVS",
                                        <br />
                                        &#125;
                                    </code>
                                </p>
                                <p>
                                    <strong>Response</strong>
                                    <code>
                                        <br />
                                        &#123;
                                        <br />
                                        "message": "Connected!"
                                        <br />
                                        &#125;
                                    </code>
                                </p>
                                <p>
                                    After this step Hessab will use the provided access token to access client data including invoices/products... based on the token permissions,
                                    That will help Hessab to do automatic retrieving of data from the client application
                                </p>
                            </p>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            <Row>
                <div className="col-12">
                    <h5 className="text-left my-4">I. Data  Exchange</h5>
                    <Card>
                        <CardBody className="bg-white">
                            <CardTitle tag="h5">1. Data Template</CardTitle>
                            <p>
                                <Trans>You can use our resources endpoint to send us the data </Trans>
                                <br />
                                <Trans>Resources endpoint : </Trans> <a href="https://hesaabaccounting.com/api/v1/resources">https://hesaabaccounting.com/api/v1/resources</a>
                            </p>
                            <p className="">
                                <Trans>The access token needs to be sent along with the request</Trans>
                            </p>

                            <div className="res my-2 py-3 border-top">
                                1.1 Customers Template
                                <div className="temp">
                                        <code style={{whiteSpace:"pre-line"}}>
                                        {
                                            `{
                                                "event": "customer.(created/updated/deleted)", 
                                                "merchant": "store_id",
                                                "data": { 
                                                    "id": 1550968832,	
                                                    "first_name": "Ahmed",
                                                    "last_name": "Hassan",
                                                    "email": "demo@demo.com",

                                                    "mobile": 555555555,
                                                    "mobile_code": "+966",

                                                    "city": "الرياض",
                                                    "country": "السعودية",
                                                    "country_code": "AE",

                                                    "currency": "SAR",
                                                    "location": "",
                                                    "More fields....":""
                                                }
                                        }
                                        `
                                        }
                                        </code>

                                        <code>
                                            
                                        </code>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            </Row>
        </Container>
    );
};

export default Docs
